export function parseBankAmount(value: string): number | null {
  const normalized = value
    .trim()
    .replace(/^NZD\s*/i, '')
    .replace(/^\$/, '')
    .replaceAll(',', '')
    .trim()
  if (!/^-?\d+(?:\.\d{1,2})?$/.test(normalized)) return null

  const negative = normalized.startsWith('-')
  const unsigned = negative ? normalized.slice(1) : normalized
  const [dollars = '0', cents = ''] = unsigned.split('.')
  const result = Number(dollars) * 100 + Number(cents.padEnd(2, '0'))
  if (!Number.isSafeInteger(result)) return null
  return negative ? -result : result
}
